import { Expose } from 'class-transformer';
import { EventSubCategoryDto } from '../../../order-management/dto/response/event-sub-category.dto';

export class GetSubCategoryResponseDto extends EventSubCategoryDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'code' })
  code: string;
  @Expose({ name: 'category_id' })
  categoryId: number;
  @Expose({ name: 'image' })
  image: string;
  @Expose({ name: 'is_active' })
  isActive: boolean;
  @Expose({ name: 'icon' })
  icon: string;
  @Expose({ name: 'sub_category' })
  subCategory: any;
}
